import {ref} from "vue";

const TOAST_VARIANTS = {
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
};

const createToast = (text, title, status, options = {}) => ({
  id: crypto.randomUUID(),
  text,
  title,
  status,
  link: options.link ?? null,
  onDismiss: options.onDismiss ?? null,
});

const addToast = (text, title = null, status = null, options = {}) => {
  const opts = typeof options === 'number' ? { timeout: options } : { ...options };
  const timeout = opts.timeout ?? 4000;

  if (toasts.value.find((toast) => toast.text === text && toast.status === status)) {
    return;
  }

  status = status ?? TOAST_VARIANTS.SUCCESS;

  const newToast = createToast(
    text,
    title ?? status.toString().charAt(0).toUpperCase() + status.slice(1),
    status,
    { link: opts.link, onDismiss: opts.onDismiss },
  );

  toasts.value = [...toasts.value, newToast];

  setTimeout(() => {
    dismissToast(newToast.id);
  }, timeout);
};

export const toasts = ref([]);

export const dismissToast = (uuid) => {
  const toast = toasts.value.find((t) => t.id === uuid);
  if (toast?.onDismiss) {
    toast.onDismiss();
  }
  toasts.value = toasts.value.filter((t) => t.id !== uuid);
};

export const successToast = (text, title, options = {}) => {
  addToast(text, title, TOAST_VARIANTS.SUCCESS, options);
};

export const infoToast = (text, title) => {
  addToast(text, title, TOAST_VARIANTS.INFO);
};

export const warningToast = (text, title) => {
  addToast(text, title, TOAST_VARIANTS.WARNING);
};

export const errorToast = (text, title) => {
  addToast(text, title, TOAST_VARIANTS.ERROR);
};
